import { useState } from "react";
import MortgageCalculator from "@/components/MortgageCalculator";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { formatEuro } from "@/lib/api";

export default function Mutuo() {
  const [rent, setRent] = useState(1200);
  const [expenses, setExpenses] = useState(150);

  return (
    <div className="min-h-[calc(100vh-56px)] bg-zinc-950">
      <div className="border-b border-white/10 p-6">
        <div className="max-w-7xl mx-auto">
          <div className="font-mono-data text-xs text-cyan-400 tracking-widest mb-2">— CALCOLATORE MUTUO</div>
          <h1 className="font-display font-black text-3xl mb-2">Simula il tuo investimento.</h1>
          <p className="text-sm text-zinc-400 max-w-2xl">
            Modifica prezzo, anticipo, tasso e durata per vedere rata, interessi e cash flow con canone di locazione.
          </p>
        </div>
      </div>

      <div className="max-w-6xl mx-auto p-6 grid lg:grid-cols-[1fr_420px] gap-6">
        <MortgageCalculator monthlyRent={rent} monthlyExpenses={expenses} />

        <div className="border border-white/10 p-5 h-fit">
          <div className="font-mono-data text-xs text-lime-400 tracking-widest mb-4">— IPOTESI LOCAZIONE</div>
          <div className="space-y-4">
            <div>
              <Label className="font-mono-data text-[10px] text-zinc-400 tracking-widest">CANONE MENSILE ATTESO</Label>
              <Input type="number" value={rent} onChange={(e) => setRent(Number(e.target.value) || 0)} className="rounded-none bg-zinc-900 border-white/10 mt-1 h-10 font-mono-data" data-testid="mutuo-rent" />
            </div>
            <div>
              <Label className="font-mono-data text-[10px] text-zinc-400 tracking-widest">SPESE MENSILI (IMU, cond., manut.)</Label>
              <Input type="number" value={expenses} onChange={(e) => setExpenses(Number(e.target.value) || 0)} className="rounded-none bg-zinc-900 border-white/10 mt-1 h-10 font-mono-data" data-testid="mutuo-expenses" />
              <div className="text-[10px] text-zinc-600 mt-1 font-mono-data">Suggerimento: {formatEuro(Math.round(15 * 80 / 12 + 800/12 + rent * 0.10))}/mese per un 80 m²</div>
            </div>
          </div>

          <div className="mt-6 pt-4 border-t border-white/10 space-y-3 text-xs text-zinc-500 font-mono-data leading-relaxed">
            <div><span className="text-zinc-300 font-bold">Rata:</span> calcolata con formula francese (rata costante).</div>
            <div><span className="text-zinc-300 font-bold">Cash-on-cash:</span> flusso netto annuo diviso capitale proprio.</div>
            <div><span className="text-zinc-300 font-bold">Payback:</span> tempo di rientro del solo anticipo alle condizioni date.</div>
          </div>
        </div>
      </div>
    </div>
  );
}
